import { defineComponent, reactive, ref, watch, toRefs, onMounted, onBeforeMount, nextTick, onBeforeUnmount } from "vue";
import container from "./components/container.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import vueSeamlessScroll from "vue-seamless-scroll/src";
import alarmAnalysisPie from "./components/alarmAnalysisPie";
import NewEcharts from '@/components/Echart/NewEcharts.vue';
import cellInfo from './components/cellInfo.vue';
import device from './components/device.vue';
import warning from './components/warning.vue';
import { weChatrequest } from '@/utils/request';
export default defineComponent({
  name: "Home",
  components: {
    container,
    NewEcharts,
    alarmAnalysisPie,
    vueSeamlessScroll,
    cellInfo,
    device,
    warning
  },
  props: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      wellPieData: {
        legend: ["在线", "离线"],
        series: [{
          name: "在线",
          value: 2
        }, {
          name: "离线",
          value: 5
        }]
      },
      levelPieData: {
        legend: ["在线", "离线"],
        series: [{
          name: "在线",
          value: 2
        }, {
          name: "离线",
          value: 5
        }]
      },
      tableData: [],
      tableData1: [],
      tableData2: [],
      scrollOption: {
        step: 0.5,
        // 数值越大速度滚动越快
        // limitMoveNum: 1, // 开始无缝滚动的数据量 this.list
        hoverStop: true,
        // 是否开启鼠标悬停stop
        direction: 1 // 0向下 1向上 2向左 3向右
      },
      bgAllImage: {
        backgroundImage: ''
      },
      bgLeftImage: {
        backgroundImage: ''
      },
      bgRightImage: {
        backgroundImage: ''
      },
      isDark: true,
      resizeTime: null,
      tableHeight: 0,
      cellData: [{
        name: "接入站点",
        value: "--",
        // src: require("@/assets/img/环网箱1.png"),
        link: ""
      }, {
        name: "接入通道",
        value: "--",
        // src: require("@/assets/img/总额定容量1.png"),
        link: ''
      }, {
        name: "接入井盖",
        value: "--",
        errValue: "--"
        // src: require("@/assets/img/终端数量1.png"),
        // link:"/module/manhole/deviceManage/twoDeviceManage"
      }, {
        name: "接入液位",
        value: "--"
        // src: require("@/assets/img/新能源电站1.png"),
        // link:"/module/manhole/deviceManage/twoDeviceManage"
      }],
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,
      showMap: false
    });
    const methods = reactive({
      goPage() {
        router.push(`/dataAnalysisMap`);
      },
      handleClick1(row) {
        router.push("/alarmManage");
      },
      handleClick(row) {
        router.push("/workManage");
        // weChatrequest({
        //   url: "/sindex/update/alarmStatus",
        //   method: "post",
        //   data:{
        //     alarmTime: row.alarmTime,
        //     deviceId: row.deviceId
        //   }
        // }).then((res) => {
        //   router.push("/module/manhole/alarmManage/alarmMonitor?id="+row.deviceId)
        // });
      },
      setTableHeight() {
        // 防抖处理
        if (state.resizeTime) {
          clearTimeout(state.resizeTime);
          state.resizeTime = null;
        }
      },
      //设备在线率
      getOnlineRate() {
        weChatrequest({
          url: "/sindex/device/online",
          method: "get"
        }).then(res => {
          state.wellPieData.series[0].value = res.data.onWellCount;
          state.wellPieData.series[1].value = res.data.offWellCount;
          state.levelPieData.series[0].value = res.data.onLevelCount;
          state.levelPieData.series[1].value = res.data.offLevelCount;
          // let fixArr=[0.955,0.965,0.96,0.97,0.953]
          // let fixRandom=0.901//fixArr[Math.floor(Math.random() * fixArr.length)];
          // let fixRandom1=0.912//fixArr[Math.floor(Math.random() * fixArr.length)];
          // state.wellPieData.series[0].value = parseInt(res.data.wellCount*fixRandom)
          // state.wellPieData.series[1].value = res.data.wellCount-parseInt(res.data.wellCount*fixRandom)
          // state.levelPieData.series[0].value = parseInt(res.data.levelCount*fixRandom1)
          // state.levelPieData.series[1].value = res.data.levelCount-parseInt(res.data.levelCount*fixRandom1)
        });
      },
      //管廊概况
      getDeviceOverview() {
        weChatrequest({
          url: "/sindex/device/overview",
          method: "get"
        }).then(res => {
          state.cellData[0].value = res.data.stationCount;
          state.cellData[1].value = res.data.channelCount;
          state.cellData[2].value = res.data.wellCount;
          state.cellData[3].value = res.data.levelCount;
        });
      },
      //告警数量前10名的设备
      getAlarmAnalysis() {
        state.loading1 = true;
        weChatrequest({
          url: "/api/v1/actuator/alarm/listAlarmOrder",
          method: "get"
        }).then(res => {
          state.loading1 = false;
          state.tableData = res.data || [];
        }).catch(() => {
          state.loading1 = false;
        });
      },
      // 最新十条告警信息
      getAlarmTable() {
        state.loading2 = true;
        weChatrequest({
          url: "/api/v1/actuator/alarm/latestAlarms",
          method: "get"
        }).then(res => {
          console.log(res, 'res2');
          state.tableData2 = res.data || [];
          state.loading2 = false;
        }).catch(() => {
          state.loading2 = false;
        });
      },
      //首页-待审核工单
      getAuditTable() {
        state.loading3 = true;
        weChatrequest({
          url: "/api/v1/actuator/audit/myTodoList",
          method: "get"
        }).then(res => {
          console.log(res, 'res2');
          // state.tableData1 = res.data || [1,2,3,4,];
          state.tableData1 = [{
            actNum: 1
          }, {
            actNum: 1
          }, {
            actNum: 1
          }, {
            actNum: 1
          }];
          state.loading3 = false;
        }).catch(() => {
          state.loading3 = false;
        });
      }
    });
    methods.getAlarmTable();
    methods.getAlarmAnalysis();
    methods.getAuditTable();
    // methods.getDeviceOverview();
    // methods.getOnlineRate();
    onMounted(() => {
      state.showMap = true;
      nextTick(() => {
        methods.setTableHeight();
        const appMain = document.getElementsByClassName("app-main")[0];
        appMain.className = "app-main setHomeAppStyle";
      });
      window.addEventListener("resize", methods.setTableHeight);
    });
    onBeforeUnmount(() => {
      const appMain = document.getElementsByClassName("setHomeAppStyle")[0];
      if (appMain) {
        appMain.className = "app-main";
      }
      window.removeEventListener("resize", methods.setTableHeight);
    });
    return {
      ...toRefs(state),
      ...toRefs(methods)
    };
  }
});